import { getDocument } from "@/lib/pdf";

export async function extractPdfTextBrowser(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer();
  const loadingTask = getDocument({ data: arrayBuffer });
  const pdf = await loadingTask.promise;

  let fullText = "";
  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const content = await page.getTextContent();
    const strings = (content.items as any[]).map((it) => it.str).filter(Boolean);
    fullText += strings.join(" ") + "\n\n";
  }

  return fullText.trim();
}
